module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container white",
    staticStyle: {
      "padding": "4%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-bottom": "3%"
    }
  }, [_c('h2', [_vm._v("LogBox Practice features")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-users"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Demographics\n        "), _c('br'), _vm._v("Sharing\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-book-medical"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("Clinical Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-paste"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Customisable clinical\n        "), _c('br'), _vm._v("templates\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-notes-medical"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Patient\n        "), _c('br'), _vm._v("Questionnaires/\n        "), _c('br'), _vm._v("PROMS\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-credit-card"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Medical Billing\n        "), _c('br'), _vm._v("system integration\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-file-upload"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Document\n        "), _c('br'), _vm._v("management and\n        "), _c('br'), _vm._v("Multimedia Storage\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-file-contract"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("Consent to practice")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-comment"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("Messaging Module")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-clinic-medical"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Pre-admissions\n        "), _c('br'), _vm._v("with integration to\n        "), _c('br'), _vm._v("Hospitals\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-file-medical-alt"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Theatre Lists and\n        "), _c('br'), _vm._v("Waiting Lists\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-server"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("\n        Database creation and\n        "), _c('br'), _vm._v("management\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "section-feature-icons-three"
  }, [_c('i', {
    staticClass: "fas fa-chart-line"
  })]), _vm._v(" "), _c('p', {
    staticClass: "feature-texts"
  }, [_vm._v("Reports and analytics")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0383d5ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PracticeFeatures.vue
// module id = 646
// module chunks = 5